import * as Types from '../../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RemoveAdministratorMutationVariables = Types.Exact<{
  input: Types.RemoveAdministratorInput;
}>;


export type RemoveAdministratorMutation = { __typename?: 'MutationRoot', removeAdministrator: { __typename?: 'RemoveAdministratorPayload', error?: string | null, administrator?: { __typename?: 'Administrator', id: string, name: string } | null } };


export const RemoveAdministratorDocument = gql`
    mutation RemoveAdministrator($input: RemoveAdministratorInput!) {
  removeAdministrator(input: $input) {
    administrator {
      id
      name
    }
    error
  }
}
    `;

export function useRemoveAdministratorMutation() {
  return Urql.useMutation<RemoveAdministratorMutation, RemoveAdministratorMutationVariables>(RemoveAdministratorDocument);
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveAdministratorMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ removeAdministrator })
 *   )
 * })
 */
export const mockRemoveAdministratorMutation = (resolver: ResponseResolver<GraphQLRequest<RemoveAdministratorMutationVariables>, GraphQLContext<RemoveAdministratorMutation>, any>) =>
  graphql.mutation<RemoveAdministratorMutation, RemoveAdministratorMutationVariables>(
    'RemoveAdministrator',
    resolver
  )
